import { type PageSize, type BlobInput } from '@oicana/browser';

export enum DocumentsWorkerResponseKind {
    Ready,
    Broken,
    Compiled,
    Page,
    Error,
}

export type DocumentsWorkerResponse =
    | {
          kind: DocumentsWorkerResponseKind.Broken | DocumentsWorkerResponseKind.Ready;
      }
    | {
          kind: DocumentsWorkerResponseKind.Compiled;
          nonce: number;
          documentToken: number;
          pages: PageSize[];
      }
    | {
          kind: DocumentsWorkerResponseKind.Page;
          nonce: number;
          preview: ArrayBuffer;
      }
    | {
          kind: DocumentsWorkerResponseKind.Error;
          nonce: number;
          message: string;
      };

export enum DocumentsWorkerRequestKind {
    Compile,
    RenderPage,
    Release,
    Disconnect,
}

export type DocumentsWorkerRequest =
    | {
          kind: DocumentsWorkerRequestKind.Compile;
          documentsApi: string;
          authToken: string;
          template: string;
          jsonDatasets: Map<string, string>;
          blobDatasets: Map<string, BlobInput>;
          nonce: number;
      }
    | {
          kind: DocumentsWorkerRequestKind.RenderPage;
          documentToken: number;
          pageIndex: number;
          pixelsPerPt: number;
          nonce: number;
      }
    | {
          kind: DocumentsWorkerRequestKind.Release;
          documentToken: number;
      }
    | {
          kind: DocumentsWorkerRequestKind.Disconnect;
      };
